import request from './request'


// 五一活动
export function getmayDayInvitenum(params) {
    return request.get(`/api/activity/getInvitenum`, { params })
}